import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchInit, setMaintenanceMode } from "../api";
import { InitVM, MaintenanceModeOptions } from "../../autogenerated/models";

export interface InitState {
  isLoading: boolean;
  data: InitVM;
}

const initialState: InitState = {
  isLoading: false,
  data: {
    user: {},
    appVersion: "",
    maintenanceMode: { isEnabled: false }
  },
};

export const initSlice = createSlice({
  name: "init",
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setData: (state, action: PayloadAction<InitVM>) => {
      state.data = action.payload;
    },
    toggleMaintenanceMode: (state, action: PayloadAction<MaintenanceModeOptions>) => {
      state.data.maintenanceMode = action.payload;
    }
  },
});

export const { actions } = initSlice;

export const getInit = () => {
  return (dispatch: any) => {
    dispatch(actions.setIsLoading(true));
    return fetchInit()
      .then((sessions) => {
        dispatch(actions.setData(sessions));
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsLoading(false)));
  };
};

export const toggleMaintenanceMode = (options: MaintenanceModeOptions) => {
  return (dispatch: any) => {
    dispatch(actions.setIsLoading(true));
    return setMaintenanceMode(options)
      .then((res) => {
        dispatch(actions.toggleMaintenanceMode(res))
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => dispatch(actions.setIsLoading(false)));
  }
}

